import { useEffect, useState } from 'react';
import { Button, Modal, Spinner } from '../../../school_panel/components/ui';
import { useBlobUrl } from '../../../school_panel/pages/paper_exams/components/useBlobUrl';

interface Props {
  photos: { id: number; url: string }[];
  index: number;
  onIndex: (i: number) => void;
  onClose: () => void;
}

export default function AnswerPhotoViewer({ photos, index, onIndex, onClose }: Props) {
  const n = photos.length;
  const { objectUrl, loading, error } = useBlobUrl(photos[index]?.url);
  const [zoom, setZoom] = useState(false);

  const go = (i: number) => { if (i >= 0 && i < n) { setZoom(false); onIndex(i); } };

  useEffect(() => {
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'ArrowLeft' && index > 0) { e.preventDefault(); setZoom(false); onIndex(index - 1); }
      else if (e.key === 'ArrowRight' && index < n - 1) { e.preventDefault(); setZoom(false); onIndex(index + 1); }
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [index, n, onIndex]);

  return (
    <Modal isOpen onClose={onClose} size="xl" title="Answer photo">
      <div className="max-h-[70vh] overflow-auto rounded-[12px] bg-surface-2">
        {loading ? (
          <div className="flex justify-center p-10"><Spinner size="md" /></div>
        ) : error || !objectUrl ? (
          <p className="p-10 text-center text-sm text-danger-ink">Couldn&apos;t load photo</p>
        ) : (
          <img src={objectUrl} alt={`Answer photo ${index + 1} of ${n}`}
            className={zoom ? 'max-w-none' : 'mx-auto max-h-[70vh] max-w-full object-contain'}
            style={zoom ? { width: '200%' } : undefined} />
        )}
      </div>
      <div className="mt-3 flex items-center justify-between gap-2">
        <Button variant="ghost" size="sm" onClick={() => setZoom((z) => !z)} aria-pressed={zoom}>Zoom</Button>
        <div className="flex items-center gap-2">
          <Button variant="ghost" size="sm" onClick={() => go(index - 1)} disabled={index === 0}>Previous</Button>
          <span className="font-mono text-xs text-muted">{`${index + 1} of ${n}`}</span>
          <Button variant="ghost" size="sm" onClick={() => go(index + 1)} disabled={index >= n - 1}>Next</Button>
        </div>
      </div>
    </Modal>
  );
}
